var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/node_modules/core-js/library/modules/_html.js
// module id = ./node_modules/babel-runtime/node_modules/core-js/library/modules/_html.js
// module chunks = 0